function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as c } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as u } from "../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as f } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as r } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as m } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import "../list-item/list-item.gator.js";
import { NgcDivider as I } from "../../../divider/gator/divider.gator.js";
import { KEY_CONSTANTS as h } from "../../../../consts/key-constants.js";
import { NgcComponent as p } from "../../../../utils/components/ngc-component.js";
var y = Object.defineProperty,
  b = Object.getOwnPropertyDescriptor,
  i = function i(t, e, l, o) {
    for (var a = o > 1 ? void 0 : o ? b(e, l) : e, n = t.length - 1, d; n >= 0; n--) (d = t[n]) && (a = (o ? d(e, l, a) : d(a)) || a);
    return o && a && y(e, l, a), a;
  };
var s = /*#__PURE__*/function (_p) {
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, arguments), _this.id = "", _this.density = "default", _this.selectable = !1, _this.multiselect = !1, _this.ariaLabelledBy = "", _this.ariaLabelledByElements = void 0, _this.ariaDescribedByElements = void 0, _this.title = "", _this.fauxFocus = !1, _this.hideCheckmarks = !1, _this._selectedListItem = null, _this._activeIndex = 0, _this._totalListItems = 0, _this._listItemsWithEventListeners = new Set();
    return _this;
  }
  _inherits(s, _p);
  return _createClass(s, [{
    key: "updated",
    value: function updated(t) {
      if (t.has("density") && this.assignChildNodeDensity(), (this.selectable || this.multiselect) && this.updateSlottedItems(), t.has("hideCheckmarks") && this.assignChildNodeHideCheckmark(), t.has("ariaLabelledByElements") && this.ariaLabelledByElements) {
        var _this$shadowRoot;
        var e = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.getElementById(this.id);
        e && (e.ariaLabelledByElements = this.ariaLabelledByElements);
      }
      if (t.has("ariaDescribedByElements") && this.ariaDescribedByElements) {
        var _this$shadowRoot2;
        var _e = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.getElementById(this.id);
        _e && (_e.ariaDescribedByElements = this.ariaDescribedByElements);
      }
      t.has("_activeIndex") && t.get("_activeIndex") !== this._activeIndex && this._setFauxFocusToCurrentItem();
    }
  }, {
    key: "render",
    value: function render() {
      return c(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div\n                class=\"gator-list\"\n                title=\"", "\"\n                role=\"", "\"\n                id=\"", "\"\n                @keydown=\"", "\"\n                ", "\n                ", "\n            >\n                <slot @slotchange=\"", "\"></slot>\n            </div>\n        "])), this.title, this.listRole, this.id, this.handleKeyUp, this.selectable ? "aria-multiselectable=\"".concat(this.multiselect, "\"") : null, this.selectable ? "aria-activedescendant=\"".concat(this._selectedListItem, "\"") : null, this.handleSlotChanged);
    }
  }, {
    key: "listRole",
    get: function get() {
      return this.selectable ? "listbox" : "list";
    }
  }, {
    key: "handleSlotChanged",
    value: function handleSlotChanged() {
      this.updateSlottedItems();
    }
  }, {
    key: "updateSlottedItems",
    value: function updateSlottedItems() {
      var _this2 = this;
      if (this.listItems) {
        this._totalListItems = 0;
        var _iterator = _createForOfIteratorHelper(this.listItems.entries()),
          _step;
        try {
          var _loop = function _loop() {
              var _ref = _step.value;
              _ref2 = _slicedToArray(_ref, 2);
              var t = _ref2[0];
              var e = _ref2[1];
              _this2._totalListItems++, _this2.selectable ? (e.selectable = !0, e.role = "option") : e.role = "listitem", _this2.multiselect && (e.multiselect = !0), _this2._listItemsWithEventListeners.has(e) || (e.addEventListener("selected", function (l) {
                _this2._selectedListItem = l.detail.id, _this2._activeIndex = t, _this2.multiselect ? (e.selected = !e.selected, e.multiselect = !0) : (_this2.unselectAllListItems(), e.selected = !0);
              }), _this2._listItemsWithEventListeners.add(e));
            },
            _ref2;
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.setCurrentListItem();
      }
    }
  }, {
    key: "setFalseFocusToValue",
    value: function setFalseFocusToValue(t) {
      if (this.listItems) {
        var _iterator2 = _createForOfIteratorHelper(this.listItems.entries()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _ref3 = _step2.value;
            var _ref4 = _slicedToArray(_ref3, 2);
            var e = _ref4[0];
            var l = _ref4[1];
            if (l.value == t) return this._activeIndex = e, l;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "setCurrentListItem",
    value: function setCurrentListItem() {
      if (!this.listItems) return;
      var t;
      this._activeIndex === -1 && (this._activeIndex = this._totalListItems - 1), this._activeIndex >= this._totalListItems && (this._activeIndex = 0);
      var _iterator3 = _createForOfIteratorHelper(this.listItems.entries()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref5 = _step3.value;
          var _ref6 = _slicedToArray(_ref5, 2);
          var e = _ref6[0];
          var l = _ref6[1];
          l.currentListItem = e === this._activeIndex, l.currentListItem && (t = l);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return t;
    }
  }, {
    key: "_setFauxFocusToCurrentItem",
    value: function _setFauxFocusToCurrentItem() {
      var _this$listItems,
        _this3 = this;
      (_this$listItems = this.listItems) === null || _this$listItems === void 0 || _this$listItems.forEach(function (t) {
        t.currentListItem ? _this3.fauxFocus ? t.falseFocus() : t.focus() : _this3.fauxFocus && t.removeFalseFocus();
      });
    }
  }, {
    key: "falseFocusFirstItem",
    value: function falseFocusFirstItem() {
      return this._activeIndex = 0, this.setCurrentListItem();
    }
  }, {
    key: "falseFocusPreviousItem",
    value: function falseFocusPreviousItem() {
      return this._activeIndex--, this.setCurrentListItem();
    }
  }, {
    key: "falseFocusNextItem",
    value: function falseFocusNextItem() {
      return this._activeIndex++, this.setCurrentListItem();
    }
  }, {
    key: "selectFalseFocusedItem",
    value: function selectFalseFocusedItem() {
      if (this.listItems) {
        var _iterator4 = _createForOfIteratorHelper(this.listItems),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var t = _step4.value;
            t.falseFocusing && t.selectItem();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "unselectAllListItems",
    value: function unselectAllListItems() {
      if (this.listItems) {
        var _iterator5 = _createForOfIteratorHelper(this.listItems),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var t = _step5.value;
            t.selected = !1;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(t) {
      switch (t.key) {
        case h.UP:
          this._activeIndex--, this.setCurrentListItem(), t.preventDefault();
          break;
        case h.DOWN:
          this._activeIndex++, this.setCurrentListItem(), t.preventDefault();
          break;
      }
    }
  }, {
    key: "nodes",
    get: function get() {
      var _this$shadowRoot3;
      return (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 || (_this$shadowRoot3 = _this$shadowRoot3.querySelector("slot")) === null || _this$shadowRoot3 === void 0 ? void 0 : _this$shadowRoot3.assignedElements();
    }
  }, {
    key: "listItems",
    get: function get() {
      var _this$shadowRoot4;
      return (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 || (_this$shadowRoot4 = _this$shadowRoot4.querySelector("slot")) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.assignedElements().filter(function (t) {
        return t.nodeName === "NGC-LIST-ITEM";
      });
    }
  }, {
    key: "assignChildNodeDensity",
    value: function assignChildNodeDensity() {
      if (this.nodes) {
        var _iterator6 = _createForOfIteratorHelper(this.nodes),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var t = _step6.value;
            (t.nodeName == "NGC-LIST-ITEM" || t.nodeName == "NGC-DIVIDER") && ((t || I).density = this.density);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
  }, {
    key: "assignChildNodeHideCheckmark",
    value: function assignChildNodeHideCheckmark() {
      if (this.listItems) {
        var _iterator7 = _createForOfIteratorHelper(this.listItems),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var t = _step7.value;
            t.hideCheckmark = this.hideCheckmarks;
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }
  }]);
}(p);
s.shadowRootOptions = _objectSpread(_objectSpread({}, u.shadowRootOptions), {}, {
  mode: "open"
});
i([r()], s.prototype, "id", 2);
i([r()], s.prototype, "density", 2);
i([r({
  type: Boolean
})], s.prototype, "selectable", 2);
i([r({
  type: Boolean
})], s.prototype, "multiselect", 2);
i([r({
  attribute: "aria-labelledby"
})], s.prototype, "ariaLabelledBy", 2);
i([r({
  type: Array,
  attribute: "aria-labelled-by-elements"
})], s.prototype, "ariaLabelledByElements", 2);
i([r({
  type: Array,
  attribute: "aria-described-by-elements"
})], s.prototype, "ariaDescribedByElements", 2);
i([r({
  attribute: "aria-describedby"
})], s.prototype, "ariaDescribedby", 2);
i([r()], s.prototype, "title", 2);
i([r({
  type: Boolean,
  attribute: "faux-focus"
})], s.prototype, "fauxFocus", 2);
i([r({
  type: Boolean,
  attribute: "hide-checkmarks"
})], s.prototype, "hideCheckmarks", 2);
i([m()], s.prototype, "_selectedListItem", 2);
i([m()], s.prototype, "_activeIndex", 2);
s = i([f("ngc-list")], s);
export { s as NgcList };